import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import css from "./datatable.module.scss";

export interface Column {
  key: string;
  label: string;
  width?: string;
}

export interface DataTableProps {
  columns: Column[];
  data: any[];
  onDelete?: (item: any) => void;
  onRowClick?: (item: any) => void;
}

const DataTable: React.FC<DataTableProps> = ({
  columns,
  data,
  onDelete,
  onRowClick,
}) => {
  return (
    <TableContainer className={css.tableContainer}>
      <Table className={css.table}>
        <TableHead>
          <TableRow className={css.headerRow}>
            {columns.map((column) => (
              <TableCell
                key={column.key}
                className={css.headerCell}
                style={{ width: column.width }}
              >
                {column.label}
              </TableCell>
            ))}
            {onDelete && (
              <TableCell className={css.headerCell} style={{ width: "80px" }}>
                Action
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow
              key={index}
              className={css.bodyRow}
              onClick={() => onRowClick && onRowClick(row)}
            >
              {columns.map((column) => (
                <TableCell key={column.key} className={css.bodyCell}>
                  {row[column.key]}
                </TableCell>
              ))}
              {onDelete && (
                <TableCell className={css.bodyCell}>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(row);
                    }}
                    className={css.deleteButton}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
